import { createContext, useState } from "react"
import API from "services/api"
import _ from "lodash"

export const DefaultFeeContext = createContext({})

const DefaultFeeProvider = (props) => {
	const [defaultfees, setDefaltFees] = useState([])

	const getDefaultFees = async (params) => {
		try {
			let { data } = await API.getDefaultFees({ params })
			setDefaltFees(data)
			return data
		} catch (error) {
			throw error
		}
	}

	return (
		<DefaultFeeContext.Provider
			value={{
				defaultfees,
				setDefaltFees,

				getDefaultFees
			}}
			{...props}
		/>
	)
}

export default DefaultFeeProvider
